export enum Report {
  ALL_EVENTS = 'ALL_EVENTS',
  EVENT_REPORT = 'EVENT_REPORT',
  COST_EXPLORER = 'COST_EXPLORER',
  DAILY_EVENT_REPORT_EMAIL = 'DAILY_EVENT_REPORT_EMAIL',
  REGISTRATION_DASHBOARD = 'REGISTRATION_DASHBOARD',
  EVENTS_DASHBOARD = 'EVENTS_DASHBOARD',
  LAB_ACCOUNT_USAGE_ANALYSIS = 'LAB_ACCOUNT_USAGE_ANALYSIS',
}
